export default "__VITE_ASSET__DPkEI5BJ__"